export const HOME = {
  emergentLink: "home-emergent-link",
  langToggle: "lang-toggle",
  navHome: "nav-home",
  navContact: "nav-contact",
  heroTitle: "hero-title",
  heroCta: "hero-cta",
  marquee: "editorial-marquee",
  manifesto: "manifesto-section",
  chapter: (slug) => `chapter-${slug}`,
  chapterVideo: (slug) => `chapter-video-${slug}`,
  chapterLogo: (slug) => `chapter-logo-${slug}`,
  scrollIndicator: "scroll-indicator",
  footer: "site-footer",
};

export const CONTACT = {
  page: "contact-page",
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  company: "contact-company",
  helpTopic: "contact-help-topic",
  heardFrom: "contact-heard-from",
  message: "contact-message",
  submit: "contact-submit",
  success: "contact-success",
};
